import React from "react";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import huertaPicture from "./img/huerta.png";
import criptosPicture from "./img/criptos.png";
import csgoPicture from "./img/csgo.png";
import programmerPicture from "./img/programmer.png";
import league from "./img/league.png";
import saludoPicture from "./img/saludo.gif";
import ProfileStyle from "./assets/LautaroGS.module.scss";
import ProfilePicture from "ProfilePictures/LautaroGS.png";
import { ProgressBar } from "react-bootstrap";

const LautaroGS: React.FC<RouteProps> = () => {
  return (
    <div className='container'>
      <div className={`row ${ProfileStyle.mainbackground}`}>
        <div className='col-md-2 pt-4 pb-3'>
          <img
            src={ProfilePicture}
            className='img-thumbnail'
            alt='...'
            width={130}
          />
        </div>
        <div className='col-md-7 pt-4 pb-3'>
          <h3 className='text-light'>Bienvenido a mi perfil, mi nombre es</h3>
          <h3 className='font-weight-bold'>Lautaro Gonzalez Scholtus</h3>
          <h5 className='text-light font-weight-bold'>
            y soy Backend Developer{" "}
            <small>(ya sabes, mi vida es un json)</small>
          </h5>
        </div>
        <div className='col-md-3 pt-4 pb-3 saludo'>
          <img src={saludoPicture} width={100} className='saludo' />
        </div>
      </div>
      <div className='row'>
        <div className={`col-md-4 ${ProfileStyle.section}`}>
          <h5 className='text-center font-weight-bold mt-2'>Sobre mi</h5>
          <p>
            Soy de Santo Tomé, Santa Fe. Tengo 23 y soy egresado de la
            Tecnicatura en Desarrollo de Software.
          </p>
          <p>Antes de programar me dedicaba a arreglar computadoras</p>

          <p>
            Me gusta analizar y hacer diagramas antes de comenzar a codear, creo
            que son procesos fundamentales
          </p>
        </div>

        <div className='col-md-4 section'>
          <h5 className='text-center font-weight-bold mt-2'>Hobbies</h5>
          <div className='row'>
            <div className='col-md-2'>
              <img src={programmerPicture} width={50} />
            </div>
            <div className='col-md-10'>
              <b>Aprender tecnologías nuevas</b>
              <p>sobre todo las que no uso en mi día a día</p>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-2'>
              <img src={huertaPicture} width={50} />
            </div>
            <div className='col-md-10'>
              <b>Huerta</b>
              <p>Cuidar mi rúcula</p>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-2'>
              <img src={csgoPicture} width={50} />
            </div>
            <div className='col-md-10'>
              <b>CS Go</b>
              <p>Jugar al counter</p>
              <p>
                Liga actual:
                <img src={league} width={50} className='ml-2' />
              </p>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-2'>
              <img src={criptosPicture} width={50} />
            </div>
            <div className='col-md-10'>
              <b>Criptomonedas</b>
              <p>Leer sobre criptos y blockchain</p>
            </div>
          </div>
        </div>
        <div className='col-md-4 section large'>
          <h5 className='text-center font-weight-bold mt-2'>
            Tecnologías preferidas
          </h5>
          <p>
            PHP
            <ProgressBar variant='danger' now={90} />
          </p>
          <p>
            Javascript
            <ProgressBar variant='danger' now={80} />
          </p>
          <p>
            MySQL
            <ProgressBar variant='danger' now={80} />
          </p>
          <p>
            JasperReports
            <ProgressBar variant='danger' now={80} />
          </p>
          <p>
            Docker
            <ProgressBar variant='info' now={40} />
          </p>
          <p>
            Java
            <ProgressBar variant='info' now={40} />
          </p>
          <p>
            NodeJS
            <ProgressBar variant='info' now={30} />
          </p>
          <p>
            NestJS
            <ProgressBar variant='warning' now={20} />
          </p>
        </div>
      </div>
    </div>
  );
};

export default new Content({
  Component: LautaroGS,
  title: "Lautaro Gonzalez Scholtus",
  route: "lautaro-gs",
  tags: ["backend"]
});
